//import { any, func, string, bool } from 'prop-types';
import React from "react";
import styled from "styled-components";
import { BloxButton } from "styled_components/Common/BloxButton";
import { STORAGE_ICONS } from "utils/StorageConstants";
import { A1 } from "styled_components/Storage/Icons/A1";

const SmallCardStyle = styled.button`
	min-width: 88px;
	max-width: 88px;
	min-height: 88px;
	max-height: 88px;
	background-color: ${(props) => props.theme.Cool_Gray_Light_3};
	box-shadow: -1px -1px 4px ${(props) => props.theme.white},
		1px 1px 4px ${(props) => props.theme.boxShadow};
	border-radius: 14px;
	border: none;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	margin: 10px;
	color: ${(props) => props.theme.DCBLOX_Gray};
	.hover {
		display: none;
	}

	.top-section {
		height: 70%;

		img {
			width: 15px;
			height: 15px;
		}
		.top-right-icon {
			position: absolute;
			top: 5px;
			right: 5px;
			width: 15px;
			height: 15px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.top-left-icon {
			position: absolute;
			display: flex;
			justify-content: center;
			align-items: center;
			top: 5px;
			left: 5px;
			width: 15px;
			height: 15px;
		}
		.main-icon {
			width: 60px;
			height: 50px;
			display: flex;
			justify-content: center;
			align-items: center;

			img {
				width: 50%;
				height: 60%;
			}
		}
		.state {
			position: absolute;
			&.pending {
				bottom: 25px;
				left: 15px;
			}
			&.deleted {
				bottom: 25px;
				left: 29px;
				color: #df6a2e;
			}
		}
	}
	.bottom-section {
		width: 100%;
		height: 30%;
		height: 20px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	&.selected {
		box-shadow: -2px -2px 4px ${(props) => props.theme.white} inset,
			2px 2px 3px ${(props) => props.theme.neomhorphicShadowDark} inset;
		background-color: ${(props) => props.theme.Cool_Gray_Light_3};
	}
	&:hover {
		box-shadow: -1px -1px 3px ${(props) => props.theme.white} inset,
			1px 1px 3px ${(props) => props.theme.neomhorphicShadowDark} inset;
		background-color: ${(props) => props.theme.Cool_Gray_Light_3};
		.hover {
			display: flex;
			-webkit-backdrop-filter: blur(9.9px);
			backdrop-filter: blur(9.9px);
			background-color: var(--Cool_Gray_Med_1);
			align-items: center;
			justify-content: center;
			position: absolute;
			width: 100%;
			height: 100%;
			z-index: 1000;
			border-radius: 14px;
			#quick-view-button {
				width: 70px;
			}
		}
	}

	@media screen and (min-width: ${(props) =>
    props.theme.res.medium}) and (max-width: ${(props) =>
  props.theme.res.high}) {
		min-width: 120px;
		max-width: 120px;
		min-height: 120px;
		max-height: 120px;
		background-color: ${(props) => props.theme.Cool_Gray_Light_3};
		box-shadow: -1px -1px 6px ${(props) => props.theme.white},
			1px 1px 6px ${(props) => props.theme.boxShadow};
		border-radius: 14px;
		border: none;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin: 12px;
		color: ${(props) => props.theme.DCBLOX_Gray};

		.hover {
			display: none;
		}
		.top-section {
			height: 70%;

			img {
				width: 15px;
				height: 15px;
			}
			.top-right-icon {
				position: absolute;
				top: 5px;
				right: 5px;
				width: 20px;
				height: 20px;
				display: flex;
				justify-content: center;
				align-items: center;
				img {
					width: 20px;
					height: 20px;
				}
			}
			.top-left-icon {
				position: absolute;
				display: flex;
				justify-content: center;
				align-items: center;
				top: 5px;
				left: 5px;
				width: 20px;
				height: 20px;
				img {
					width: 20px;
					height: 20px;
				}
			}
			.main-icon {
				width: 90px;
				height: 80px;
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 50%;
					height: 60%;
				}
			}
			.state {
				position: absolute;
				&.pending {
					bottom: 27px;
					left: 27px;
				}
				&.deleted {
					bottom: 27px;
					left: 40px;
					color: #df6a2e;
				}
			}
		}
		.bottom-section {
			width: 100%;
			height: 30%;
			height: 20px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		&.selected {
			box-shadow: -2px -2px 4px ${(props) => props.theme.white} inset,
				2px 2px 3px ${(props) => props.theme.neomhorphicShadowDark} inset;
			background-color: ${(props) => props.theme.Cool_Gray_Light_3};
		}
		&:hover {
			box-shadow: -1px -1px 3px ${(props) => props.theme.white} inset,
				1px 1px 3px ${(props) => props.theme.neomhorphicShadowDark} inset;
			background-color: ${(props) => props.theme.Cool_Gray_Light_3};
			.hover {
				#quick-view-button {
					width: 100px;
				}
			}
		}
	}

	@media screen and (min-width: ${(props) => props.theme.res.high}) {
		min-width: 200px !important;
		max-width: 200px;
		min-height: 200px !important;
		max-height: 200px;
		background-color: ${(props) => props.theme.Cool_Gray_Light_3};
		box-shadow: -2px -2px 6px ${(props) => props.theme.white},
			2px 2px 6px ${(props) => props.theme.boxShadow};
		border-radius: 14px;
		border: none;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin: 25px;
		color: ${(props) => props.theme.DCBLOX_Gray};
		.hover {
			display: none;
		}
		.top-section {
			height: 70%;

			img {
				width: 15px;
				height: 15px;
			}
			.top-right-icon {
				position: absolute;
				top: 10px;
				right: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 45px;
				height: 40px;
				img {
					width: 45px;
					height: 40px;
				}
			}
			.top-left-icon {
				position: absolute;
				display: flex;
				justify-content: center;
				align-items: center;
				top: 10px;
				left: 10px;
				width: 45px;
				height: 40px;
				img {
					width: 45px;
					height: 40px;
				}
			}
			.main-icon {
				width: 165px;
				height: 135px;
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 50%;
					height: 60%;
				}
			}
			.state {
				position: absolute;
				&.pending {
					bottom: 43px;
					left: 57px;
				}
				&.deleted {
					bottom: 43px;
					left: 72px;
					color: #df6a2e;
				}
			}
		}
		.bottom-section {
			width: 100%;
			height: 30%;
			height: 20px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		&.selected {
			box-shadow: -2px -2px 4px ${(props) => props.theme.white} inset,
				2px 2px 3px ${(props) => props.theme.neomhorphicShadowDark} inset;
			background-color: ${(props) => props.theme.Cool_Gray_Light_3};
		}
		&:hover {
			box-shadow: -1px -1px 3px ${(props) => props.theme.white} inset,
				1px 1px 3px ${(props) => props.theme.neomhorphicShadowDark} inset;
			background-color: ${(props) => props.theme.Cool_Gray_Light_3};
			.hover {
				#quick-view-button {
					width: 150px;
				}
			}
		}
	
`;

export const SmallCard = ({
  key,
  id,
  onClick,
  data,
  module,
  selected,
  cypressId,
  customClass,
  pending,
  deleted,
  hoverButton,
  hoverClick,
  index,
  type,
}) => {
  const Icon = STORAGE_ICONS[data?.mainIcon]
    ? STORAGE_ICONS[data?.mainIcon]
    : A1;

  return (
    <SmallCardStyle
      id={id}
      className={`small-card ${customClass} ${selected}`}
      onClick={() => onClick(id)}
      module={module}
      data-cy={cypressId}
      key={key}
    >
      {hoverButton && (
        <div className="hover">
          <BloxButton
            id="quick-view-button"
            text="View"
            module="storage"
            enabled={true}
            onClick={hoverClick}
            cypressId={`quick-view-${index}`}
            className="buttons41"
          />
        </div>
      )}
      <div className="top-section">
        {data?.topLeftIcon && (
          <div className="top-left-icon">
            <img src={data?.topLeftIcon} />
          </div>
        )}
        {data?.topRightIcon && (
          <div className="top-right-icon">
            <img src={data?.topRightIcon} />
          </div>
        )}
        <div className="main-icon">
          {type !== "share" ? (
            <div className="main-icon">
              <img src={data?.mainIcon} />
            </div>
          ) : (
            <Icon color={data?.iconColor ? data?.iconColor : "#00b0b9"} />
          )}
        </div>
        {pending && (
          <span className="state pending labels20">PROVISIONING</span>
        )}
        {deleted && <span className="state deleted labels20">DELETED</span>}
      </div>
      <div className="bottom-section body10">{data.name}</div>
    </SmallCardStyle>
  );
};
// ActionButton.propTypes = {

// };

// ActionButton.defaultProps = {

// };
